// libs
import React from 'react';
import PropTypes from 'prop-types';
import { LocaleString } from '@biw/intl';

export const PerPeriod = ( { children, calculationLabel } ) => (
    <p className="per-period">
        &#40;{ children }&#47;<LocaleString code={ `goal.perperiod.${calculationLabel}label` } />&#41;
    </p>
);

PerPeriod.propTypes = {
    children: PropTypes.node,
    calculationLabel: PropTypes.string
};

